<script setup lang="ts">
const open = defineModel<boolean>("open", { default: false });

defineProps<{
  empty?: boolean;
}>();

defineEmits<{
  apply: [];
  clear: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="flex items-center gap-2 min-w-0">
    <AppFilterBar v-model:open="open" class="grow">
      <template #chips>
        <slot name="chips" />
      </template>
    </AppFilterBar>

    <USlideover
      v-model:open="open"
      side="left"
      :title="t('ui.filters.slideoverTitle')"
      :description="t('ui.filters.slideoverDescription')"
      :close="{ icon: 'icon:close', square: true, color: 'neutral', variant: 'ghost', size: 'lg' }"
      :ui="{
        header: 'px-6 pt-6 pb-4 border-b-0',
        title: 'text-2xl font-semibold text-primary',
        body: 'px-6 py-4 border-b-0',
        footer: 'px-6 pb-6 pt-4 flex justify-start gap-2',
        overlay: 'bg-primary/75',
        content: 'w-105 max-w-full sm:ring-none sm:shadow-none',
        description: 'sr-only',
      }"
    >
      <template #body>
        <slot v-if="empty" name="empty">
          <p class="text-blue-600 py-4">{{ t("ui.filters.empty") }}</p>
        </slot>
        <slot />
      </template>

      <template #footer>
        <UButton variant="outline" color="primary" @click="$emit('clear')">
          {{ t("ui.filters.clear") }}
        </UButton>
        <UButton color="secondary" variant="solid" @click="$emit('apply')">
          {{ t("ui.filters.apply") }}
        </UButton>
      </template>
    </USlideover>
  </div>
</template>
